/**
 * v-auth
 * 按钮权限指令
 */
import type { Directive } from "vue";

const focus: Directive = {
    mounted(el: HTMLElement) {
        el.querySelector("input")?.focus();
    }
};

export default focus;
